import { usePipelineStages } from "./dealData";

// Name of a deal's stage from pipeline_stages (task 1.7); the stage key of
// Atomic's deals.stage while the stages load or for a deal without one.
export const TenaxStageName = ({
  stageId,
  fallback,
}: {
  stageId?: number | null;
  fallback?: string;
}) => {
  const { data: stages = [] } = usePipelineStages();
  const stage = stages.find((item) => item.id === stageId);
  return <>{stage?.name ?? fallback ?? ""}</>;
};
